var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from "react";
import VoiceComponent from "../components/VoiceComponent";
var defaultTheme = {
    primaryColor: '#6366F1',
    secondaryColor: '#A78BFA',
    backgroundColor: '#0F0F14',
    headerTextColor: '#F1F1F4',
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    borderRadius: '16px',
    buttonColor: '',
    chatBubbleUser: '#6366F1',
    chatBubbleBot: '#1A1A24',
    formAccentColor: '#6366F1',
    mode: 'dark',
};
/** Build CSS custom properties from theme config.
 *  NOTE: --tb-bg, --tb-text, --tb-bubble-user, --tb-bubble-bot are NOT set
 *  inline because they're managed by the CSS (dark default + .talkbot-widget--light).
 *  Inline custom-properties override class-based ones, breaking light mode. */
function buildThemeVars(theme) {
    var t = __assign(__assign({}, defaultTheme), theme);
    return {
        '--tb-primary': t.primaryColor,
        '--tb-primary-light': t.secondaryColor,
        '--tb-font': t.fontFamily,
        '--tb-radius': t.borderRadius,
    };
}
var Widget = function (_a) {
    var _b;
    var _c, _d, _e, _f, _g, _h, _j;
    var config = _a.config;
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    var _k = useState(false), isOpen = _k[0], setIsOpen = _k[1];
    var _l = useState(((_c = config === null || config === void 0 ? void 0 : config.theme) === null || _c === void 0 ? void 0 : _c.mode) || 'dark'), themeMode = _l[0], setThemeMode = _l[1];
    var accentColor = ((_d = config === null || config === void 0 ? void 0 : config.theme) === null || _d === void 0 ? void 0 : _d.primaryColor) || defaultTheme.primaryColor;
    var _m = useState({
        horizontal: ((_e = config === null || config === void 0 ? void 0 : config.position) === null || _e === void 0 ? void 0 : _e.side) || 'right',
        vertical: 'bottom'
    }), inset = _m[0], setInset = _m[1];
    var toggleChat = function () {
        setIsOpen(!isOpen);
    };
    var toggleThemeMode = function () {
        setThemeMode(function (prev) { return prev === 'dark' ? 'light' : 'dark'; });
    };
    var themeVars = buildThemeVars(config === null || config === void 0 ? void 0 : config.theme);
    return (React.createElement("div", { className: "talkbot-widget ".concat(themeMode === 'light' ? 'talkbot-widget--light' : ''), style: __assign(__assign({}, themeVars), { '--tb-accent': accentColor, '--tb-accent-hover': accentColor, '--tb-accent-glow': "".concat(accentColor, "44"), '--tb-accent-gradient': "linear-gradient(135deg, ".concat(accentColor, " 0%, ").concat(accentColor, "cc 50%, ").concat(accentColor, "99 100%)"), position: 'fixed', left: 0, top: 0, userSelect: 'none', zIndex: 9999, pointerEvents: 'auto', fontFamily: 'var(--tb-font)' }) },
        React.createElement(VoiceComponent, { position: {
                side: inset.horizontal,
                verticalAlign: inset.vertical,
                offset: (_b = {},
                    _b[inset.vertical] = '20px',
                    _b[inset.horizontal] = '20px',
                    _b)
            }, header: config === null || config === void 0 ? void 0 : config.header, isOpen: isOpen, onClose: function () { return setIsOpen(false); }, onToggle: toggleChat, email: ((_f = config === null || config === void 0 ? void 0 : config.livekit) === null || _f === void 0 ? void 0 : _f.email) || 'user@example.com', language: ((_g = config === null || config === void 0 ? void 0 : config.livekit) === null || _g === void 0 ? void 0 : _g.language) || 'en', domain: ((_h = config === null || config === void 0 ? void 0 : config.livekit) === null || _h === void 0 ? void 0 : _h.domain) || 'demo.talkingbot.ai', avatarConfig: config === null || config === void 0 ? void 0 : config.avatar, mode: ((_j = config === null || config === void 0 ? void 0 : config.livekit) === null || _j === void 0 ? void 0 : _j.mode) || 'avatar', themeMode: themeMode, onToggleTheme: toggleThemeMode })));
};
export default Widget;
